import {
  MutationTree,
} from 'vuex';

import {
  SystemMessage,
} from '@/components/SystemMessages/types';
import {
  types,
} from '@/store/modules/system-messages/mutation-types';
import {
  State,
} from '@/store/modules/system-messages/types';

export const mutations: MutationTree<State> = {
  [types.ADD](state: State, message: SystemMessage) {
    state.list.push(message);
  },

  [types.REMOVE](state: State, id: number) {
    const index = state.list.findIndex((message: SystemMessage) => message.id === id);

    state.list.splice(index, 1);
  },

  [types.CLEAR](state: State) {
    state.list = [];
  },
};
